<template>
  <div class="step">
    <div class="step-wrapper">
      <h2>Лечение</h2>
      <p class="description">Выберите несколько верных ответов</p>
      <div class="items">
        <div v-for="(item, index) in items" class="item" :key="item.title" :class="itemClass(item)">
          <div class="item-title" @click="checkItem(item)">
            <img class="input" :src="checkboxState(item)" />
            <span v-html="item.title" />
            <div class="treat-popup treat-popup--1" v-if="item.name === 'q-2' && answered">
              Динамическая компенсация путем<br>
              <b>вестибулярной реабилитации</b><br>
              за счет механизмов адаптации,<br>
              замещения и габитуации<sup>1</sup>
            </div>
            <div class="treat-popup treat-popup--2" v-if="item.name === 'q-4' && answered">
              <div class="treat-packs">
                <div class="treat-pack">
                  <img src="@/assets/treatment-pack-1.png">
                  Стимуляция центральной <br>
                  компенсации: <b>Бетасерк<sup>®</sup></b> – <br>
                  бетагистина дигидрохлорид <br>
                  24 мг 2 раза в день – <br>
                  <b>в течение всего времени <br>
                  компенсации 2–6 мес<sup>2</sup></b>
                </div>
                <div class="treat-pack treat-pack--color">
                  <img src="@/assets/treatment-pack-2.png">
                  Теперь доступен<br>
                  Бетасерк<sup>®</sup> Лонг 48 мг: всего<br>
                  1 таблетка в сутки позволяет<br>
                  контролировать симптомы<br>
                  головокружения и повышает<br>
                  приверженность лечению!
                </div>
              </div>
            </div>
          </div>
          <hand v-if="index === 0 && showItemHand" class="hand" :right="true" />
        </div>
      </div>
      <div v-if="!answered" class="step-button" @click="answered = true"><span>Ответить<hand v-if="!showItemHand" /></span></div>
    </div>
    <div class="step-next" @click="$emit('step', 'repeated')">
      <span>Повторый прием</span>
      <svg viewBox="0 0 27 12" width="27" height="12">
        <path fill="#FFF" fill-rule="evenodd" d="M.01 5h17.14C15.83 3.07 15.17 1.8 15.1.09c3.01 2.96 6.93 4.5 11.67 5.95C22.03 7.43 18.29 9.12 15.1 12c.2-1.86.75-2.99 2.1-5.04H0V5z"/>
      </svg>
    </div>
    <div class="step-help">
      <div class="video-opener" @click="$emit('video', 'help-4-2')">
        <span>
          <img src="@/assets/help.png">
          Видеоуроки <br>упражнений
        </span>
      </div>
      <div class="video-opener" @click="$emit('video', 'help-4-1')">
        <span>
          <img src="@/assets/video.png">
          Видео-подсказка
        </span>
        <hand />
      </div>
    </div>
  </div>
</template>

<script>
import Hand from './hand'

export default {
  components: {
    Hand
  },
  data () {
    return {
      answered: false,
      items: [
        {
          name: 'q-1',
          title: 'Диуретики',
          checked: false,
          correct: false
        },
        {
          name: 'q-2',
          title: 'Вестибулярная реабилитация',
          checked: false,
          correct: true
        },
        {
          name: 'q-3',
          title: 'Репозиционные <br>лечебные маневры',
          checked: false,
          correct: false
        },
        {
          name: 'q-4',
          title: 'Бетасерк<sup>®</sup>',
          checked: false,
          correct: true
        },
        {
          name: 'q-5',
          title: 'Топироматы',
          checked: false,
          correct: false
        },
        {
          name: 'q-6',
          title: 'Антидепрессанты',
          checked: false,
          correct: false
        }
      ]
    }
  },
  computed: {
    showItemHand () {
      return !this.items.some(
        el => el.checked === true
      )
    }
  },
  methods: {
    checkItem (item) {
      if (!this.answered) {
        item.checked = !item.checked
      }
    },
    itemClass (item) {
      return {
        'item--error': !item.correct && this.answered,
        'item--correct': item.correct && this.answered
      }
    },
    checkboxState (item) {
      const state = item.checked ? (!this.answered || item.correct ? 'checkbox-on' : 'checkbox-error') : 'checkbox-off'
      return require('@/assets/' + state + '.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.treat-popup  {
  position: absolute;
  background: #fff;
  border: 1px solid #009cde;
  border-radius: 3px;
  padding: 15px;
  box-shadow: 0 6px 12px 2px rgba(170, 204, 219, .34);
  font-weight: normal;
  z-index: 5;
  color: #282828;
  font-size: 16px;
  line-height: 1;
  transform: translate(90%, 0);

  @include media-down(lg) {
    font-size: 14px;
    padding: 10px;
  }

  @include media-down(md) {
    position: static !important;
    margin: 10px 0 0 -20px !important;
    transform: none !important;

    &:before,
    &:after {
      display: none;
    }
  }

  b {
    color: #009cde;
  }

  &--1 {
    bottom: 100%;

    &:before {
      content: '';
      position: absolute;
      left: 5px;
      top: 100%;
      border-top: 15px solid #009cde;
      border-left: 5px solid transparent;
      border-right: 10px solid transparent;
      transform-origin: 50% 0;
      transform: skewX(-20deg);
    }
    &:after {
      content: '';
      position: absolute;
      left: 6px;
      top: 100%;
      margin-top: -2px;
      border-top: 15px solid #fff;
      border-left: 5px solid transparent;
      border-right: 10px solid transparent;
      transform-origin: 50% 0;
      transform: skewX(-20deg);
    }

    @include media-down(lg) {
      transform: translate(100%, 40%);

    &:before {
      content: '';
      position: absolute;
      right: 100%;
      top: 40px;
      left: auto;
      border-right: 20px solid #009cde;
      border-top: 5px solid transparent;
      border-bottom: 10px solid transparent;
      transform-origin: 100% 50%;
      transform: skewY(-20deg);
    }
    &:after {
      content: '';
      position: absolute;
      right: 100%;
      top: 41px;
      left: auto;
      margin-right: -2px;
      border-right: 19px solid #fff;
      border-top: 5px solid transparent;
      border-bottom: 10px solid transparent;
      transform-origin: 100% 50%;
      transform: skewY(-22deg);
    }
    }
  }
  &--2 {
    top: 100%;
    margin: 40px 0 0;
    transform: translate(0, -50%);
    left: 190px;
    padding: 0;

    &:before {
      content: '';
      position: absolute;
      right: 100%;
      top: 80px;
      border-right: 50px solid #009cde;
      border-top: 10px solid transparent;
      border-bottom: 15px solid transparent;
      transform-origin: 100% 50%;
      transform: skewY(20deg);

      @include media-down(lg) {
        top: 50px;
      }
    }
    &:after {
      content: '';
      position: absolute;
      right: 100%;
      top: 81px;
      margin-right: -2px;
      border-right: 49px solid #fff;
      border-top: 10px solid transparent;
      border-bottom: 15px solid transparent;
      transform-origin: 100% 50%;
      transform: skewY(20deg);

      @include media-down(lg) {
        top: 51px;
      }
    }

    @include media-down(lg) {
      left: 160px;
    }
  }
}
.treat-packs {
  display: flex;
  align-items: stretch;

  @include media-down(md) {
    display: block;
    text-align: center;
  }
}
.treat-pack {
  white-space: nowrap;
  padding: 15px;

  @include media-down(lg) {
    padding: 10px;
  }

  &--color {
    background-image: -webkit-linear-gradient( 0deg, rgb(89,190,196) 0%, rgb(81,180,191) 34%, rgb(55,147,179) 64%, rgb(18,99,160) 100%);
    color: #fff;
    font-weight: bold;
  }

  img {
    display: block;
    margin: 0 auto;

    @include media-down(lg) {
      height: 80px !important;
      width: auto;
    }
  }
  b {
    color: #009cde;
  }
}
.description {
  font-size: 16px;
  color: #252628;
  margin: 0;
  padding: 0;
  font-style: italic;
}
.items {
  padding: 0 160px 0 0;
  margin: 0 0 32px;

  @include media-down(lg) {
    margin: 0 0 24px;
  }
  @include media-down(md) {
    padding: 0;
    margin: 0;
  }
}
.item {
  margin: 20px 0 20px 20px;
  line-height: 1.1;
  position: relative;

  .hand {
    top: 20px;
    left: -60px;
  }

  @include media-down(lg) {
    margin: 15px 0 15px 20px;
  }

  &-title {
    color: #252628;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    position: relative;

    @include media-down(lg) {
      font-size: 16px;
    }

    .input {
      position: absolute;
      left: -20px;
      top: .15em;
    }
  }

  &--correct &-title {
    color: #009cde;
  }
  &--error &-title {
    color: #cd0000;
  }

  &-description {
    font-size: 16px;
    color: #252628;
    margin: 5px 0 0;
  }
}
.step-help {
  height: auto;

  &:before {
    height: 340px;
    width: 340px;

    @include media-down(lg) {
      width: 260px;
      height: 260px;
    }
  }
  .video-opener {
    height: 120px;

    @include media-down(lg) {
      height: 110px;
    }

    &:first-child {
      border-radius: 16px 16px 0 0;
      margin: 0 0 3px;
    }
    &:last-child {
      border-radius: 0 0 16px 16px;
    }
  }
}
</style>
